import type { Rank } from '@/types/product'

export const sortByRank = <T extends { rank: Rank }>(items: T[]) => {
  const rankOrder: { [key in Rank]: number } = {
    s: 1,
    a: 2,
    b: 3,
    c: 4
  }

  return [...items].sort((a, b) => rankOrder[a.rank] - rankOrder[b.rank])
}
